import { all, put, takeLatest, call } from 'redux-saga/effects';
import { WebLauncherLandingActionTypes, WebLaunchRequest } from 'types';
import {
  getWebLaunchRequestSuccess,
  getWebLaunchRequestFailure
} from './actions';
import { getWebLauncher } from 'services/weblauncher.service';

function* handleGetWebLaunchRequest(request: any) {
  try {
    const response: WebLaunchRequest = yield getWebLauncher(request.payload);
    yield put(getWebLaunchRequestSuccess(response));
  } catch (err) {
    yield put(getWebLaunchRequestFailure('Unable to load request'));
  }
}

function* watchGetWebLaunchRequest() {
  yield takeLatest(
    WebLauncherLandingActionTypes.GET_WEB_LAUNCHER_START,
    handleGetWebLaunchRequest
  );
}

function* webLauncherLandingSagas() {
  yield all([call(watchGetWebLaunchRequest)]);
}

export default webLauncherLandingSagas;
